import React from 'react';
import { makeStyles } from '@material-ui/styles';
import VerifiedUserRoundedIcon from '@material-ui/icons/VerifiedUserRounded';

import { COMPANY_NAME_MISSING } from '../constants';
import { getIsEmpBadgeByEmpData } from '../employerHelper';

import AfitdTypography from './AfitdTypography';

import cx from 'clsx';
import _get from 'lodash/get';

const useStyles = (params = {}) => {
    const isCenterText = _get(params, 'props.isCenterText');

    return makeStyles(theme => ({
        root: { padding: '10px 0', display: 'flex', alignItems: 'flex-end', justifyContent: isCenterText ? 'center' : undefined },
        companyName: { fontWeight: 'bold' },
        verifyIcon: { color: '#1D8A8B', margin: '0 5px' },
    }));
};

const AfitdCompanyName = props => {
    const { isHidden, className, companyName: companyNameProp, isEmpBadge: isEmpBadgeProp, employerData, companyNameProps, verifyIconProps } = props;

    const classes = useStyles({ props })();

    if (isHidden) {
        return null;
    } else {
        const rootCls = cx(classes.root, className);
        const companyNameCls = classes.companyName;
        const verifyIconCls = classes.verifyIcon;

        const companyName = companyNameProp !== undefined ? companyNameProp : _get(employerData, 'companyName') ? _get(employerData, 'companyName') : COMPANY_NAME_MISSING;
        const isEmpBadge = isEmpBadgeProp !== undefined ? isEmpBadgeProp : getIsEmpBadgeByEmpData(employerData);

        return (
            <div className={rootCls}>
                <AfitdTypography variant="body1" className={companyNameCls} {...companyNameProps}>
                    {companyName}
                </AfitdTypography>
                {isEmpBadge && <VerifiedUserRoundedIcon className={verifyIconCls} {...verifyIconProps} />}
            </div>
        );
    }
};

export default AfitdCompanyName;
